import { RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  time_labels: {
    today: 'Hoy',
    asap: 'Lo antes posible',
    scheduled: '{{date}}, {{time}}',
  },
  [RoomServiceLocationType.RoomService]: {
    details_label: 'Número de habitación',
  },
  [RoomServiceLocationType.TableService]: {
    details_label: 'Número de mesa',
  },
};
